import { Routes, RouterModule } from '@angular/router';
import { MatchComponent } from './match/match.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { MatchesGuard } from './guards/matches.guard';

const appRoutes: Routes = [
  { path: 'game/:id', component: MatchComponent, canActivate: [MatchesGuard] },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: true, enableTracing: true });
